import { gql } from "@apollo/client";

export const GET_MASTER_DATA_PRODUCT_UOMS = gql`
  query MasterDataProductUoms($params: MasterDataProductUomsParamsInput!) {
    masterDataProductUoms(params: $params) {
      count
      items {
        uomId
        uomCode
        uomName
        uomDescription
        isLinked
      }
    }
  }
`;
